module.exports = __webpack_public_path__ + "img/custom-item2-5.302d8e9.png";